'use client';

import { useState, useEffect } from 'react';



interface Alert {
  id: number;
  type: 'critical' | 'urgent' | 'info';
  title: string;
  description: string;
  location: string;
  timestamp: string;
  action: string;
  actionLink: string;
}

const UrgentAlerts = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const alerts: Alert[] = [
    {
      id: 1,
      type: 'critical',
      title: 'Poaching Activity Detected',
      description: 'Increased movement detected in Sector 7 of Kruger National Park. Additional ranger patrols deployed.',
      location: 'Kruger National Park, South Africa',
      timestamp: '2 hours ago',
      action: 'Support Emergency Response',
      actionLink: '/impact-dashboard-homepage'
    },
    {
      id: 2,
      type: 'urgent',
      title: 'Drought Relief Needed',
      description: 'Water sources critically low in Etosha. Emergency water delivery required for rhino populations.',
      location: 'Etosha National Park, Namibia',
      timestamp: '5 hours ago',
      action: 'Contribute to Relief Fund',
      actionLink: '/impact-dashboard-homepage'
    },
    {
      id: 3,
      type: 'info',
      title: 'New Calf Born',
      description: 'Successful birth of white rhino calf in Ol Pejeta Conservancy. Mother and calf in good health.',
      location: 'Ol Pejeta Conservancy, Kenya',
      timestamp: '1 day ago',
      action: 'View Success Story',
      actionLink: '/field-reports'
    }
  ];

  const getAlertStyles = (type: string) => {
    switch (type) {
      case 'critical':
        return {
          bg: 'bg-error/10',
          border: 'border-error',
          icon: 'ExclamationTriangleIcon',
          iconBg: 'bg-error',
          iconColor: 'text-error-foreground',
          badge: 'bg-error text-error-foreground'
        };
      case 'urgent':
        return {
          bg: 'bg-warning/10',
          border: 'border-warning',
          icon: 'BellAlertIcon',
          iconBg: 'bg-warning',
          iconColor: 'text-warning-foreground',
          badge: 'bg-warning text-warning-foreground'
        };
      case 'info':
        return {
          bg: 'bg-success/10',
          border: 'border-success',
          icon: 'InformationCircleIcon',
          iconBg: 'bg-success',
          iconColor: 'text-success-foreground',
          badge: 'bg-success text-success-foreground'
        };
      default:
        return {
          bg: 'bg-muted',
          border: 'border-border',
          icon: 'InformationCircleIcon',
          iconBg: 'bg-muted',
          iconColor: 'text-muted-foreground',
          badge: 'bg-muted text-muted-foreground'
        };
    }
  };

  if (!isHydrated) {
    return (
      <section className="py-16 lg:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-2">
                Live Conservation Alerts
              </h2>
              <p className="text-lg text-muted-foreground font-body">
                Real-time updates from conservation zones requiring immediate attention
              </p>
            </div>
          </div>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-card rounded-lg p-6 shadow-organic-sm border border-border">
                <div className="h-24 bg-muted animate-pulse rounded" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return null;
};

export default UrgentAlerts;